import { Link } from 'react-router-dom';
import { t } from '../i18n';

export default function PartnersPage() {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">{t('Партнери')}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Link
          to="/partners/list"
          className="block p-4 bg-white rounded-lg shadow hover:shadow-md hover:bg-blue-50 transition"
        >
          <h3 className="text-lg font-semibold text-blue-600 mb-2">{t('Преглед на партнери')}</h3>
          <p className="text-gray-500">{t('Листа на сите партнери.')}</p>
        </Link>
        <Link
          to="/partners/add"
          className="block p-4 bg-white rounded-lg shadow hover:shadow-md hover:bg-green-50 transition"
        >
          <h3 className="text-lg font-semibold text-green-600 mb-2">{t('Додади партнер')}</h3>
          <p className="text-gray-500">{t('Додадете нов партнер.')}</p>
        </Link>
      </div>
    </>
  );
}
